var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn && _vm.playerFavorites
    ? _c(
        "div",
        { staticClass: "my-events-page myeventssettings" },
        [
          !_vm.mobileBigAndBelow || !_vm.accountSummaryFlow
            ? [_c("h1", [_vm._v(_vm._s(_vm.$t("Favorites.MyEventsSettings")))])]
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileBigAndBelow && _vm.accountSummaryFlow
            ? [
                _c(
                  "div",
                  { staticClass: "account-heading" },
                  [
                    _c("icon", { attrs: { name: "icon-acc-settings" } }),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("Favorites.MyEventsSettings")) +
                        "\n    "
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "my-events-settings-page-content" },
            [
              _c(
                "v-tabs",
                {
                  staticClass: "favorite-tabs",
                  attrs: { "fixed-tabs": "", "align-with-title": "" }
                },
                [
                  _c(
                    "v-tab",
                    {
                      class: { active: _vm.selectedTab === "favorites" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.selectTab("favorites")
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Favorites.MyEvents.Tabs.Favorites"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.favTabs && _vm.favTabs.includes("FrequentlyPlayed")
                    ? _c(
                        "v-tab",
                        {
                          class: {
                            active: _vm.selectedTab === "frequentlyPlayed"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.selectTab("frequentlyPlayed")
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Favorites.MyEvents.Tabs.FrequentlyPlayed")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-tab",
                    {
                      class: { active: _vm.selectedTab === "notifications" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.selectTab("notifications")
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Favorites.MyEvents.Tabs.Notifications"))
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedTab === "favorites" || !_vm.selectedTab
                ? [
                    !_vm.isProcessingFavorites
                      ? _c(
                          "div",
                          [
                            _c(
                              "v-flex",
                              {
                                staticClass: "search-bar",
                                class: { mobile: _vm.mobileBigAndBelow }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "input-group",
                                    class: {
                                      "non-empty": _vm.searchFavoritesPhrase
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "search-fields-container"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "search-icon" },
                                          [
                                            _c("icon", {
                                              attrs: { name: "icon-search" }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.searchFavoritesPhrase,
                                              expression:
                                                "searchFavoritesPhrase"
                                            }
                                          ],
                                          ref: "phrase",
                                          staticClass: "search-filed",
                                          attrs: {
                                            type: "search",
                                            name: "search-filed",
                                            placeholder: _vm.$t(
                                              "Favorites.MyEvents.Search"
                                            ),
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: _vm.searchFavoritesPhrase
                                          },
                                          on: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.searchFavorites()
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.searchFavoritesPhrase =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("button", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.searchFavoritesPhrase,
                                              expression:
                                                "searchFavoritesPhrase"
                                            }
                                          ],
                                          staticClass: "reset-icon",
                                          attrs: { type: "reset" },
                                          on: {
                                            click: function($event) {
                                              return _vm.resetFavoritesSearchPhrase()
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.filteredAllFavorites &&
                            _vm.filteredAllFavorites.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "favorites" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "favorites-header" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col col-1" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "label" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Favorites.Betslip.Team_Player"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col col-2" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "label" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Favorites.Betslip.Favorite"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col col-3" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "label" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Favorites.Betslip.NotifyMe"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.filteredAllFavorites, function(
                                      favorit,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "favorite-item",
                                          class: {
                                            active:
                                              favorit.enabled &&
                                              !favorit.isfromsearch &&
                                              _vm.searchFavoritesResults &&
                                              _vm.searchFavoritesResults
                                                .length > 0
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col col-1" },
                                            [
                                              _c("icon", {
                                                attrs: {
                                                  name:
                                                    "icon-" +
                                                    ((favorit.idfosporttype &&
                                                      favorit.idfosporttype.replace(
                                                        / /g,
                                                        ""
                                                      )) ||
                                                      "empty")
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("div", [
                                                favorit.type === "P" ||
                                                favorit.type === "C"
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "label" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(favorit.name)
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                favorit.type === "S" ||
                                                favorit.type === "L"
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "label" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            favorit.idfosporttype
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col col-2" },
                                            [
                                              _c("v-checkbox", {
                                                key: index,
                                                attrs: { label: "" },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.editFavorite(
                                                      {
                                                        source: favorit.source,
                                                        type: favorit.type,
                                                        idfosporttype:
                                                          favorit.idfosporttype,
                                                        favoriteid:
                                                          favorit.favoriteid,
                                                        name: favorit.name
                                                          ? favorit.name
                                                          : null,
                                                        order: favorit.order,
                                                        language:
                                                          favorit.language,
                                                        enabled: favorit.enabled
                                                          ? true
                                                          : false,
                                                        tonotify: favorit.tonotify
                                                          ? true
                                                          : false
                                                      },
                                                      index
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.filteredAllFavorites[
                                                      index
                                                    ].enabled,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filteredAllFavorites[
                                                        index
                                                      ],
                                                      "enabled",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filteredAllFavorites[index].enabled"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col col-3" },
                                            [
                                              favorit.tonotify !== null
                                                ? _c("v-checkbox", {
                                                    key: index + "_notify",
                                                    attrs: {
                                                      label: "",
                                                      disabled: !_vm
                                                        .filteredAllFavorites[
                                                        index
                                                      ].enabled
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.editFavorite(
                                                          {
                                                            source:
                                                              favorit.source,
                                                            type: favorit.type,
                                                            idfosporttype:
                                                              favorit.idfosporttype,
                                                            favoriteid:
                                                              favorit.favoriteid,
                                                            name: favorit.name
                                                              ? favorit.name
                                                              : null,
                                                            order:
                                                              favorit.order,
                                                            language:
                                                              favorit.language,
                                                            enabled: favorit.enabled
                                                              ? true
                                                              : false,
                                                            tonotify: favorit.tonotify
                                                              ? true
                                                              : false
                                                          },
                                                          index
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm
                                                          .filteredAllFavorites[
                                                          index
                                                        ].tonotify,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm
                                                            .filteredAllFavorites[
                                                            index
                                                          ],
                                                          "tonotify",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "filteredAllFavorites[index].tonotify"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.searchFavoritesPhrase &&
                            _vm.searchFavoritesPhrase.length >=
                              _vm.numOfCharsToStartSearch &&
                            _vm.searchInProgress
                              ? _c(
                                  "div",
                                  { staticClass: "search-fav-loading" },
                                  [_c("dots-loader")],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.searchFavoritesPhrase &&
                            _vm.searchFavoritesPhrase.length >=
                              _vm.numOfCharsToStartSearch &&
                            !_vm.searchInProgress &&
                            !(
                              _vm.searchFavoritesResults &&
                              _vm.searchFavoritesResults.length > 0
                            )
                              ? _c(
                                  "div",
                                  { staticClass: "favorites-noresults" },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(
                                          _vm.$t("Favorites.NoResultsFound")
                                        ) +
                                        "\n        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filteredAllFavorites &&
                            _vm.filteredAllFavorites.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "fav_buttons" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "save_btn",
                                        attrs: {
                                          disabled:
                                            _vm.updatedFavorites.length === 0
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.saveFavorites()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Favorites.MyEventsSettings.Btn.Save"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "clear_btn",
                                        on: {
                                          click: function($event) {
                                            return _vm.clearAll()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Favorites.MyEventsSettings.Btn.Clear"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.favTabs &&
                            _vm.favTabs.includes("FrequentlyPlayed")
                              ? _c(
                                  "div",
                                  { staticClass: "fav_buttons reset" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "clear_btn",
                                        on: {
                                          click: function($event) {
                                            return _vm.openResetFavoritesDialog()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Favorites.MyEventsSettings.Btn.ResetFavorites"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isProcessingFavorites
                      ? _c(
                          "div",
                          { staticClass: "update_favorites" },
                          [_c("dots-loader")],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-dialog",
                      {
                        attrs: { "max-width": "400" },
                        model: {
                          value: _vm.resetFavoritesDialog,
                          callback: function($$v) {
                            _vm.resetFavoritesDialog = $$v
                          },
                          expression: "resetFavoritesDialog"
                        }
                      },
                      [
                        _c(
                          "v-card",
                          { staticClass: "favorites_confirmaition_dialog" },
                          [
                            _c("v-card-text", { staticClass: "tl-alert-msg" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Favorites.MyEventsSettings.Btn.ResetFavoritesConfirm"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-card-actions",
                              { staticClass: "fav_buttons" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "save_btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.resetFavorites()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Favorites.MyEventsSettings.Btn.Reset"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "clear_btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.closeResetFavoritesDialog()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Favorites.MyEventsSettings.Btn.Cancel"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedTab === "frequentlyPlayed"
                ? [
                    !_vm.isProcessingFavorites &&
                    _vm.frequentlyPlayedFavorites &&
                    _vm.frequentlyPlayedFavorites.length > 0
                      ? _c(
                          "div",
                          { staticClass: "favorites_fp" },
                          [
                            _vm._l(_vm.frequentlyPlayedFavorites, function(
                              favorit,
                              index
                            ) {
                              return _c(
                                "div",
                                { key: index, staticClass: "favorite-item" },
                                [
                                  _c("icon", {
                                    attrs: {
                                      name:
                                        "icon-" +
                                        ((favorit.idfosporttype &&
                                          favorit.idfosporttype.replace(
                                            / /g,
                                            ""
                                          )) ||
                                          "empty")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    favorit.type === "P" || favorit.type === "C"
                                      ? _c("span", [
                                          _vm._v(_vm._s(favorit.name))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    favorit.type === "S" || favorit.type === "L"
                                      ? _c("span", [
                                          _vm._v(_vm._s(favorit.idfosporttype))
                                        ])
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "fav_buttons" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "clear_btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.clearFPList()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Favorites.MyEventsSettings.Btn.ClearFP"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isProcessingFavorites &&
                    !(
                      _vm.frequentlyPlayedFavorites &&
                      _vm.frequentlyPlayedFavorites.length > 0
                    )
                      ? _c("div", { staticClass: "favorites_fp empty_list" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("Favorites.MyEventsSettings.FPListEmpty")
                              ) +
                              "\n      "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isProcessingFavorites
                      ? _c(
                          "div",
                          { staticClass: "update_favorites" },
                          [_c("dots-loader")],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedTab === "suggested" ? void 0 : _vm._e(),
              _vm._v(" "),
              _vm.selectedTab === "notifications"
                ? [
                    !_vm.isProcessingPreferences
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "ctsform fav_notifications_form" },
                            [
                              _c("div", { staticClass: "notification_item" }, [
                                _c(
                                  "div",
                                  { staticClass: "notifications_header" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Favorites.MyEventsSettings.Notification"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "control-block cs",
                                    class: {
                                      filled: _vm.notificationBeforeStart
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      staticClass: "custom-select",
                                      attrs: {
                                        "menu-props": {
                                          contentClass: "select_list"
                                        },
                                        id: "notification_interval",
                                        items:
                                          _vm.notificationBeforeStartOptions,
                                        label: ""
                                      },
                                      model: {
                                        value: _vm.notificationBeforeStart,
                                        callback: function($$v) {
                                          _vm.notificationBeforeStart =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "notificationBeforeStart"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "control-label" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Favorites.MyEventsSettings.Notification.Desc"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "notification_item" }, [
                                _c(
                                  "div",
                                  { staticClass: "notifications_header" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Favorites.MyEventsSettings.Notification.Max"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "desc" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Favorites.MyEventsSettings.Notification.Max.Desc"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "control-block",
                                    class: {
                                      filled: _vm.notificationsMaxPerDay
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.notificationsMaxPerDay,
                                          expression: "notificationsMaxPerDay"
                                        }
                                      ],
                                      attrs: {
                                        type: "text",
                                        inputmode: "numeric",
                                        id: "notificationsMaxPerDay",
                                        autocomplete: "off",
                                        maxlength: "50"
                                      },
                                      domProps: {
                                        value: _vm.notificationsMaxPerDay
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.notificationsMaxPerDay =
                                            $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "control-label" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Favorites.MyEventsSettings.Notification.Max.Placeholder"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.maxNotificationsError
                                  ? _c("div", [
                                      _c("div", {
                                        staticClass: "vmsg invalid",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "Favorites.MyEventsSettings.Notification.Max.Error"
                                            )
                                          )
                                        }
                                      })
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "fav_buttons" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "save_btn",
                                      attrs: {
                                        disabled: _vm.maxNotificationsError
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.saveCustomerPreferences()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Favorites.MyEventsSettings.Btn.Save"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "clear_btn",
                                      on: {
                                        click: function($event) {
                                          return _vm.cancelUpdatepreferences()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Favorites.MyEventsSettings.Btn.Cancel"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isProcessingPreferences
                      ? _c(
                          "div",
                          { staticClass: "update_favorites" },
                          [_c("dots-loader")],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad8db00c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad8db00c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/MyEventsSettings.vue
// module id = null
// module chunks = 